<template>
    <div>
        <v-dialog v-model="storageType" class="storage-type-dialog" width="500px" persistent>
            <v-card>
                <v-card-title>
                    <h3>{{$t('Выберите тип хранилища ключа для ЭЦП')}}</h3>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="selectedTypeOfStorage"
                        :items="typeOfStorages"
                        :label="$t('Выберите')"
                        class="pl-2 pr-2"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="onCloseECPDialog(false)">{{$t('Отмена')}}</v-btn>
                    <v-btn
                        :disabled="!selectedTypeOfStorage"
                        flat
                        @click="onCloseECPDialog(true)"
                    >{{$t('Продолжить')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteConfirmActive" class="storage-type-dialog" width="500px" persistent>
          <v-card>
            <v-card-title>
              <h3>{{$t('Удалить заявку')}}</h3>
            </v-card-title>
            <v-card-text>
              <p>{{$t('Данное действие необратимо, Вы действительно хотите удалить заявку?»')}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="deleteConfirmActive = false">{{$t('Нет')}}</v-btn>
              <v-btn
                flat
                @click="handleDelete"
              >{{$t('Да')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <RequestForm
            v-bind:isLoading="requestLoading"
            v-bind:isLoadingMessage="isLoadingMessage"
            v-bind:vfgSchema="visibleRequestSchema"
            v-bind:vfgModel="localModel"
            v-bind:actions="translatedLocalActions"
            v-bind:errorMessage="errorMessage"
            :showInfoMessage="isDraft"
            :showAgreeCheckBox="showAgreeCheckBox"
            v-on:submitOK="handleSubmitOK"
            v-on:submitCancel="handleSubmitCancel"
            v-on:delete="openDeleteConfirm"
        >
            <template v-if="localModel.mainData" v-slot:header>
                <div class="header_container clearfix">
                    <div class="header_title block">
                        <h2
                            style="color:#1976D2;"
                        >{{$t('Заявка')}} №{{localModel.mainData.requestNumber}} ({{$t(localModel.mainData.requestType)}})</h2>
                    </div>
                    <div class="main_data block">
                        <div>
                            <div v-if="localModel.mainData.author">
                                <p class="label">{{$t('Автор')}}</p>
                                <p class="value">{{localModel.mainData.author}}</p>
                            </div>
                            <div v-if="localModel.mainData.createDateTime">
                                <p class="label">{{$t('Дата создания')}}</p>
                                <p class="value">{{localModel.mainData.createDateTime | formatDate}}</p>
                            </div>
                        </div>

                        <div>
                            <div v-if="localModel.mainData.status">
                                <p class="label">{{$t('Статус')}}</p>
                                <p class="value">{{$t(localModel.mainData.status)}}</p>
                            </div>
                            <div v-if="localModel.mainData.signedDateTime">
                                <p class="label">{{$t('Дата подписания')}}</p>
                                <p class="value">{{localModel.mainData.signedDateTime | formatDate}}</p>
                            </div>
                        </div>
                        <div>
                            <div v-if="signInfo.fio">
                                <p class="value">{{$t('Подписано ЭЦП')}}</p>
                                <p class="value">
                                    <label>{{$t('ИИН')}}:</label>
                                    {{signInfo.iin}}
                                </p>
                                <p class="value">
                                    <label>{{$t('ФИО')}}:</label>
                                    {{signInfo.fio}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </RequestForm>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions, mapGetters } from 'vuex';
import RequestForm from '../components/RequestForm';
import { transformToOneLevel, objectToBase64String } from '../utility/routines';
import { createCAdESFromBase64 } from '../services/sign.service';
import {
    BPM_DECISION_PROPERTY_NAME,
    STATUS_DRAFT,
    BLOCK_MAIN_DATA,
    BLOCK_ANSWER_DATA,
    BLOCK_METER_INDICATIONS_DATA_ONE,
    BLOCK_METER_INDICATIONS_DATA_TWO,
    BLOCK_METER_INDICATIONS,
    BLOCK_METER_INDICATIONS_DATA,
    BLOCK_METER_INDICATIONS_DAY,
    BLOCK_METER_INDICATIONS_NIGHT,
    ACTION_VALUE_CANCEL,
    BLOCK_FILES_REQUIRED,
    TYPE_PROCESS_TARIFF_CHANGE,
    TYPE_PROCESS_SEAL_INSTALL
} from '../config/consts';
import MobileDetect from "mobile-detect";

export default {
    name: 'ProcessForm',
    props: ['requestId', 'processId', 'status'],
    components: { RequestForm },
    data: () => ({
        status_draft: STATUS_DRAFT,
        errorMessage: '',
        isLoadingMessage: '',
        selectedTypeOfStorage: 'PKCS12',
        selectedTypeOfStoragePromiseResolve: undefined,
        storageType: false,
        deleteConfirmActive: false,
        localModel: {},
        localActions: [
            {
                code: 'submitOK',
                title: 'Отправить',
                color: 'primary',
                Type: 'submit',
                disabled: false
            },
            {
                code: 'submitCancel',
                title: 'Закрыть без сохранения',
                color: '',
                Type: 'reset',
                disabled: false
            },
            {
                code: 'delete',
                title: 'Удалить заявку',
                color: '',
                Type: 'delete',
                disabled: false,
            }
        ]
    }),
    computed: {
        ...mapGetters('request', ['processDocumentFolderID', 'processName', 'visibleRequestSchema']),

        ...mapState('request', ['needSign', 'signInfo', 'requestLoading', 'requestData']),
        ...mapGetters('user', ['isConsumer', 'isROESUser', 'isRESUser', 'userNeedSign', 'userAccounts']),
        typeOfStorages() {
            return [
                { text: this.$t('Ваш Компьютер'), value: 'PKCS12' },
                { text: this.$t('Казтокен'), value: 'AKKaztokenStore' },
                { text: this.$t('Личное Удостоверение'), value: 'AKKZIDCardStore' },
                { text: this.$t('EToken Java 72k'), value: 'AKEToken72KStore' },
                { text: this.$t('AK JaCarta'), value: 'AKJaCartaStore' }
            ];
        },
        needSignLocal: function() {
            return this.needSign && this.userNeedSign;
        },
        translatedLocalActions() {
            return this.localActions.map(action => {
                action.title = this.$t(action.title);
                return action;
            });
        },
        showAgreeCheckBox() {
            return this.isConsumer && this.isDraft;
        },
        title() {
            return 'Выполнение';
            // return this.localModel.mainData.requestType + ' №' + this.localModel.mainData.requestNumber;
        },
        isDraft() {
            return this.status === this.status_draft;
        }
    },
    methods: {
        ...mapActions('user', ['addAccountsToSchema', 'getAccountInfo', 'getAccountCntInfo', 'getAccountTariffInfo', 'getAccountUnsealInfo']),
        ...mapActions('bpm', ['completeProcess']),
        ...mapActions('request', [
            'prepareExecuteTask',
            'getDocumentSignInfo',
            'updateRequest',
            'swithRequestLoading',
            'uploadRequiredFiles',
            'uploadOtherFiles',
            'getAcceptDocuments',
            'getEdsInfo',
            'deleteRequest'
        ]),
        async getAccountUnsealInfoLocal(accountNumber) {
            this.$set(this.localModel.accountsData, 'unsealDate', undefined);
            this.$set(this.localModel.accountsData, 'unsealPlace', undefined);
            this.$set(this.localModel.accountsData, 'sealNumber', undefined);

            let res = await this.getAccountUnsealInfo(accountNumber);
            this.$set(this.localModel.accountsData, 'unsealDate', res.date_id ? moment(String(res.date_id)).format('DD.MM.YYYY') : undefined);
            this.$set(this.localModel.accountsData, 'unsealPlace', res.place_name);
            this.$set(this.localModel.accountsData, 'sealNumber', res.seal_number);
        },
        async accountNumberNotChangedForPause() {
            let accountNumberBefore = this.localModel.accountsData.account_number;
            await new Promise(r => setTimeout(r, 500));
            return accountNumberBefore === this.localModel.accountsData.account_number;
        },
        async updateCntIndicationsInfo(accountNumber) {
            let indications = this.localModel.meterIndicationsData || {};
            this.$set(this.localModel, 'meterIndicationsData', {});
            let res = await this.getAccountCntInfo(accountNumber);

            if (res) {
                indications.meterName = res.cnt_factory_number;
                indications.lastIndicationsDate = res.indications_date_id ? moment(String(res.indications_date_id)).format('DD.MM.YYYY') : undefined;
                indications.lastIndications = res.indications_1;
                indications.lastIndicationsDay = res.indications_1;
                indications.lastIndicationsNight = res.indications_2;
            } else {
                indications.meterName = undefined;
                indications.lastIndicationsDate = undefined;
                indications.lastIndications = undefined;
                indications.lastIndicationsDay = undefined;
                indications.lastIndicationsNight = undefined;
            }
            this.$set(this.localModel, 'meterIndicationsData', indications);
        },
        async getAccountTariffInfoLocal(accountNumber) {
            let res = await this.getAccountTariffInfo(accountNumber);
            this.$set(this.localModel.accountsData, 'currentTariff', res.current_tariff);
            this.$set(this.localModel.accountsData, 'newTariff', res.tariff_to_change);
        },
        async getAccountInfoLocal(accountNumber, identityCardField) {
            let accountInfo = await this.getAccountInfo(accountNumber);
            if (accountInfo.account_id) {
                this.localActions[0].disabled = false;
                this.$set(identityCardField, 'visible', !accountInfo.identity_card);
                if (accountInfo.identity_card) {
                    delete this.localModel.requestFiles.IdentityCard;
                }
            }
        },

        getDataForSign() {
            let dataForSign = {};
            for (let key in this.localModel) {
                if (key !== BLOCK_MAIN_DATA && key !== BLOCK_ANSWER_DATA) {
                    dataForSign[key] = this.localModel[key];
                }
            }
            return dataForSign;
        },
        async selectTypeOfStorage() {
            let outer = this;
            return new Promise(function(resolve, reject) {
                outer.selectedTypeOfStoragePromiseResolve = resolve;
            });
        },
        onCloseECPDialog(isContinue) {
            this.storageType = false;
            this.selectedTypeOfStoragePromiseResolve(isContinue);
            this.selectedTypeOfStoragePromiseResolve = undefined;
        },
        async handleSubmitOK(value) {
            let objectAccountNumber = null;
            try {
                this.errorMessage = '';
                this.swithRequestLoading(true);

                if (this.localModel.accountsData && this.localModel.accountsData.account_number) {
                    if (typeof this.localModel.accountsData.account_number === 'object') {
                        objectAccountNumber = this.localModel.accountsData.account_number;
                        this.localModel.accountsData.accountName = objectAccountNumber.account_name;
                        this.localModel.accountsData.address = objectAccountNumber.address;
                        this.localModel.accountsData.account_number = objectAccountNumber.account_id;
                        this.localModel.accountsData.roes = objectAccountNumber.roes_code_name;
                        this.localModel.accountsData.roes_name___Ru = objectAccountNumber.roes_div_name;
                        this.localModel.accountsData.roes_name___Kk = objectAccountNumber.roes_div_name_kz;
                        this.localModel.accountsData.res = objectAccountNumber.res_code_name;
                        this.localModel.accountsData.res_name___Ru = objectAccountNumber.res_div_name;
                        this.localModel.accountsData.res_name___Kk = objectAccountNumber.res_div_name_kz;
                    } else {
                        if (this.isDraft) {
                            let accountInfo = await this.getAccountInfo(this.localModel.accountsData.account_number);
                            if (accountInfo.account_id) {
                                this.localModel.accountsData.accountName = accountInfo.account_name;
                                this.localModel.accountsData.address = accountInfo.address;
                                this.localModel.accountsData.roes = accountInfo.roes_code_name;
                                this.localModel.accountsData.roes_name___Ru = accountInfo.roes_div_name;
                                this.localModel.accountsData.roes_name___Kk = accountInfo.roes_div_name_kz;
                                this.localModel.accountsData.res = accountInfo.res_code_name;
                                this.localModel.accountsData.res_name___Ru = accountInfo.res_div_name;
                                this.localModel.accountsData.res_name___Kk = accountInfo.res_div_name_kz;
                            } else {
                                this.errorMessage = this.$t('Такой лицевой счет не существует');
                                return;
                            }
                        }
                    }
                }

                // обновляем документ - обновляем данными с формы ввода
                if (!(await this.uploadRequiredFiles(this.localModel))) {
                    //show dialog with upload error
                    this.swithRequestLoading(false);
                    this.errorMessage = this.$t('Ошибка загрузки файла.Пожалуйста,попробуйте еще раз');
                    return;
                }

                if (!(await this.uploadOtherFiles(this.localModel))) {
                    //show dialog with upload error
                    this.swithRequestLoading(false);
                    this.errorMessage = this.$t('Ошибка загрузки файла.Пожалуйста,попробуйте еще раз');
                    return;
                }
                if (this.needSignLocal && (this.isDraft || (!this.isDraft && this.needSignLocal && value && value !== ACTION_VALUE_CANCEL))) {
                    try {

                      //Проверяем, если мобильное устройство, то ошибка
                      const md = new MobileDetect(window.navigator.userAgent);

                      //if(window.innerWidth <= 768){
                      if (md.mobile()) {
                        this.errorMessage = this.$t('validators.isMobile');
                        return;
                      }
                      //-----------------------------------------

                        this.isLoadingMessage = this.$t('Подтверждение заявки ЭЦП');
                        this.storageType = true;
                        if (await this.selectTypeOfStorage()) {
                            let res = await createCAdESFromBase64(objectToBase64String(this.getDataForSign()), this.selectedTypeOfStorage);
                            if (res) {
                                if (res === 'notConnected') {
                                    this.errorMessage = this.$t('Ошибка при подключении к NCALayer.');
                                    return;
                                } else if (res === 'storage.empty') {
                                    this.errorMessage = this.$t('Выбранный тип хранилища пуст.');
                                    return;
                                }
                                this.localModel.mainData.sign = res;
                                this.localModel.mainData.signedDateTime = moment().format();
                            } else {
                                return;
                            }
                        } else {
                            return;
                        }

                      // Для акцепта делаем валидацию эцп
                      if (this.localModel.hasOwnProperty('acceptData')) {
                        const edsUser = await this.getEdsInfo(this.localModel);
                        const requestAccount = this.localModel.accountsData.account_number;
                        const account = this.userAccounts.find(item => item.account_id === requestAccount);
                        if(!account || account.iin !== edsUser.iin){
                          this.errorMessage = this.$t('validators.iinNotMatch');
                          return;
                        }
                      }

                    } finally {
                        this.isLoadingMessage = '';
                    }
                }

                // Для акцепта подтягиваем документы с бэка
                if (this.localModel.hasOwnProperty('acceptData')) {
                  await this.getAcceptDocuments();
                }

                if (!(await this.updateRequest({ requestId: this.requestId, requestData: this.localModel }))) {
                    //show dialog with update error
                    this.swithRequestLoading(false);
                    this.errorMessage = this.$t('Ошибка обновления запроса.Пожалуйста,попробуйте еще раз');
                    return;
                }

                let data = transformToOneLevel(this.localModel);
                data.id = this.requestId;

                if (value) {
                    data[BPM_DECISION_PROPERTY_NAME] = value;
                }

                // выполняем шаг
                let completeResponce = await this.completeProcess({ processId: this.processId, data: data });
                if (completeResponce.success) {
                    this.$router.push('/');
                } else {
                    //show message with complete error
                    this.swithRequestLoading(false);
                    this.errorMessage = completeResponce.message;
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.swithRequestLoading(false);
                if (this.localModel.accountsData && this.localModel.accountsData.account_number && objectAccountNumber) {
                    this.localModel.accountsData.account_number = objectAccountNumber;
                }
            }
        },
        handleSubmitCancel() {
            this.$router.back();
        },
        openDeleteConfirm(){
            this.deleteConfirmActive = true;
        },
        async handleDelete(){
            try {
                this.swithRequestLoading(true);
                await this.deleteRequest(this.requestId);
                this.$router.push('/');
            } catch (err) {
                console.log(err);
            } finally {
                this.swithRequestLoading(false);
            }
        }
    },
    created() {
        if (!this.requestId || !this.processId || !this.status) {
            this.$router.back();
        }
    },
    async mounted() {
        try {
            this.swithRequestLoading(true);

            this.getDocumentSignInfo(this.requestId);

            let bpmActions = await this.prepareExecuteTask({
                processId: this.processId,
                requestId: this.requestId
            });

            this.localModel = this.requestData;

            if (bpmActions && bpmActions.length) {
                this.localActions = bpmActions;
            }

            let one = this.visibleRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_ONE);
            let two = this.visibleRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_TWO);
            if (one && two) {
                let requestFilesBlock = this.visibleRequestSchema.find(schema => schema.code === BLOCK_FILES_REQUIRED);
                let identityCardField = requestFilesBlock.schema.fields.find(field => field.model === 'requestFiles.IdentityCard');

                if (this.isROESUser || this.isRESUser) {
                    if (this.isDraft || this.localModel[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS]) {
                        this.$set(two, 'hide', true);
                        this.localActions[0].disabled = true;
                        if (this.localModel.accountsData.account_number) {
                            this.updateCntIndicationsInfo(this.localModel.accountsData.account_number);
                            this.getAccountInfoLocal(this.localModel.accountsData.account_number, identityCardField);
                        }

                        this.$watch('localModel.accountsData.account_number', async () => {
                            this.localActions[0].disabled = true;
                            this.$set(identityCardField, 'visible', true);
                            if (await this.accountNumberNotChangedForPause()) {
                                //not changed throughout 3 sec
                                this.updateCntIndicationsInfo(this.localModel.accountsData.account_number);
                                this.getAccountInfoLocal(this.localModel.accountsData.account_number, identityCardField);
                            }
                        });
                    } else {
                        this.$set(one, 'hide', true);
                    }
                } else {
                    if (this.isDraft) {
                        if (!this.localModel.accountsData.account_number) {
                            //если черновик и не выбран лицевой счет , то по умолчанию показываем однотарифное
                            this.$set(two, 'hide', true);
                        }
                    } else {
                        //если обычный пользователь и не черновик
                        //то смотрим на заполненность показаний
                        //и скрываем незаполненные
                        let showFirst = this.localModel[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS];
                        this.$set(one, 'hide', !showFirst);
                        this.$set(two, 'hide', showFirst);
                    }

                    this.$watch('localModel.accountsData.account_number', () => {
                        if (
                            this.localModel.accountsData &&
                            this.localModel.accountsData.account_number &&
                            typeof this.localModel.accountsData.account_number === 'object'
                        ) {
                            let showFirst = this.localModel.accountsData.account_number.indications_count == 1;

                            this.$set(one, 'hide', !showFirst);
                            this.$set(two, 'hide', showFirst);

                            try {
                                if (showFirst) {
                                    delete this.localModel[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS_DAY];
                                    delete this.localModel[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS_NIGHT];
                                } else {
                                    delete this.localModel[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS];
                                }
                            } catch (e) {
                                console.log(e);
                            }

                            this.updateCntIndicationsInfo(this.localModel.accountsData.account_number.account_id);
                            if (identityCardField) {
                                this.$set(identityCardField, 'visible', !this.localModel.accountsData.account_number.identity_card);
                            }
                        }
                    });
                }
            } else if (this.localModel.mainData.requestType === TYPE_PROCESS_TARIFF_CHANGE) {
                if (this.isROESUser || this.isRESUser) {
                    this.$watch('localModel.accountsData.account_number', async () => {
                        if (await this.accountNumberNotChangedForPause()) {
                            this.getAccountTariffInfoLocal(this.localModel.accountsData.account_number);
                        }
                    });
                } else {
                    this.$watch('localModel.accountsData.account_number', async () => {
                        if (
                            this.localModel.accountsData &&
                            this.localModel.accountsData.account_number &&
                            typeof this.localModel.accountsData.account_number === 'object'
                        ) {
                            this.getAccountTariffInfoLocal(this.localModel.accountsData.account_number.account_id);
                        }
                    });
                }
            } else if (this.localModel.mainData.requestType === TYPE_PROCESS_SEAL_INSTALL) {
                if (this.isROESUser || this.isRESUser) {
                    this.$watch('localModel.accountsData.account_number', async () => {
                        if (await this.accountNumberNotChangedForPause()) {
                            this.getAccountUnsealInfoLocal(this.localModel.accountsData.account_number);
                        }
                    });
                } else {
                    this.$watch('localModel.accountsData.account_number', async () => {
                        if (
                            this.localModel.accountsData &&
                            this.localModel.accountsData.account_number &&
                            typeof this.localModel.accountsData.account_number === 'object'
                        ) {
                            this.getAccountUnsealInfoLocal(this.localModel.accountsData.account_number.account_id);
                        }
                    });
                }
            }

            this.addAccountsToSchema({ schemaIn: this.visibleRequestSchema, model: this.localModel });
        } catch (e) {
            console.log(e);
        } finally {
            this.swithRequestLoading(false);
        }
    }
};
</script>